import React from "react";

/** Headline metric tile — icon + label + big serif value + optional sub-label. */
const KpiCard = ({ icon: Icon, label, value, sub, testId }) => (
  <div
    data-testid={testId}
    className="border border-[#F2EBE5]/10 bg-[#0a0a0a] p-6"
  >
    <div className="flex items-center justify-between">
      <Icon className="w-5 h-5 text-[#C5A059]" strokeWidth={1.25} />
      <span className="text-[9px] uppercase tracking-[0.3em] text-[#A19E9C]">
        {label}
      </span>
    </div>
    <p className="mt-6 font-serif-display text-4xl text-[#F2EBE5]">{value}</p>
    {sub && <p className="mt-2 text-xs text-[#A19E9C]">{sub}</p>}
  </div>
);

export default KpiCard;
